export default __webpack_public_path__ + "static/media/alarm-clock.31a7c321.png";